<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import { SET_USER_LOGGED } from "../src/store/auth/action.type";
export default {
  name: "app",
  mounted() {
    //prevent redirecting to login page on clicking back button when localstorage is not empty
    window.onpopstate = event => {
      if (
        window.localStorage.getItem(
          "GiftRegistryAccessToken" + process.env.VUE_APP_ACCESS_TOKEN_NAME
        ) !== null &&
        this.$route.path == "/"
      ) {
        this.$store.dispatch(SET_USER_LOGGED, true);
        this.$router.push("/dashboard");
      }
    };
  }
};
</script>
<style>
html {
  overflow-x: hidden;
  overflow-y: auto;
}
/* @import "https://fonts.googleapis.com/css?family=Pacifico&display=swap";
@import "https://fonts.googleapis.com/css?family=Rubik:400,500&display=swap";*/
@import "../public/assets/css/style.css";
@import "../public/assets/css/custom.css";
</style>
